import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'

import Home from '@/components/Home'
import CaseStudy from '@/components/CaseStudy'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        home: Home
      }
    },
    {
      path: '/case-studies/:cs',
      name: 'cs',
      components: {
        cs: CaseStudy
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  next(
    (to.meta.guarded && store.state.token === '') ? {name: 'login'} : true
  )
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js